<template lang="pug">
div
  .table-responsive
    table.table.table-new
      thead
        tr
          th {{ $t("ui.bet_time") }}
          th {{ $t("ui.event") }}
          th {{ $t("ui.odds") }}
          th {{ $t("ui.stake") }}
          th {{ $t("ui.winlose") }}
          th {{ $t("ui.status") }}
          th {{ $t("ui.turnover") }} 
      template(v-if="!loading")
        tbody(v-if="list && list.length > 0")
          tr(v-for="item in list")
            td.text-start 
              div {{ item.result_id }}
              .text-secondary.small {{ $moment(item.bet_time).format("YYYY-MM-DD HH:mm:ss") }}
            td.text-start
              template(v-if="[45,46].includes(item.sports_type)")
                div {{ $t('ui.'+ item.sports_category.toLowerCase()) }} - {{ getBetTypeName(item.bet_type) }}
                div.small {{ getBetDisplay(item) }}
                div.small(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(item.bet_type)") {{ item.bet_hand.split(" ")[0] }}
                div.small {{item.home_team_name}}
                div.small {{item.league_name}}
              template(v-else)
                template(v-if="item.bet_type != 'PARLAY'")
                  div {{ $t('ui.'+ item.sports_category.toLowerCase()) }} - {{ getBetTypeName(item.bet_type) }}
                  div.small {{ getBetDisplay(item) }}
                  div.small(v-if="['HDP', 'HDPH', 'OU', 'OUH', '1X2HDP', '1X2HDPH'].includes(item.bet_type)") {{ item.bet_hand.split(" ")[1] }}
                  div.small {{item.home_team_name}}
                  div.small {{item.away_team_name}}
                  div.small {{item.league_name}}
                template(v-else)
                  div {{ getBetTypeName(item.bet_type) }} @ {{ item.odds_display_bet }}
            td
              div(:class="{ 'text-danger': parseFloat(item.odds_display) < 0 }") {{ item.odds_display == 0 ? item.odds_display : formatOddsDisplay(item.odds_display, item.bet_type) }}
            td
              div {{ $numeral(item.bet_amount).format("0,0.00") }}
            td
              div(:class="$helpers.getNumberClass(item.winlose)") {{ $numeral(item.winlose).format("0,0.00") }}
            td
              div(:class="$helpers.getNumberClass(item.winlose)") {{ parseFloat(item.winlose) != 0 ? (parseFloat(item.winlose) < 0 ? $t("ui.lost") : $t("ui.win")) : $t("ui.draw") }}
            td 
              div(:class="$helpers.getNumberClass(item.turnover)") {{ $numeral(item.turnover).format("0,0.00") }}       
        tbody(v-else)
          tr
            td(colspan=7) {{ $t('ui.no_record') }}    
      template(v-else)
        tbody
          tr
            td(colspan=7) 
              i.fas.fa-sync.fa-spin
  .pagenumber.my-4
    paginate(
      v-if="list && list.length > 0"
      :click-handler="changePage"
      :pageCount="pageCount"
      :page-range="4"
      :margin-pages="3"
      :prev-text="''"
      :next-text="''"
      :container-class="'p-0 m-center'"
      :page-class="'round'"
      :page-link-class="''"
      :prev-class="'round prev'"
      :next-class="'round next'"
      :prev-link-class="pageCount > 1 && currentPage != 1 ? '' : ''"
      :next-link-class="pageCount > 1 && currentPage != pageCount ? '' : ''"
    )

</template>

<script>
import config from '@/config'

export default {
  components: {
    paginate: () => import("vuejs-paginate")
  },
  props: {
    list: {
      type: Array,
      default: []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      feedback: {
        status: "",
        success: ""
      },
      currentPage: 1,
      providerType: "casino"
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    workingDate() {
      return this.$store.getters.workingDate
    },
    pageSize() {
      return this.$store.getters.pageSize
    },
    getLanguage() {
      return this.$store.getters.language
    },
    pageCount() {
      if (this.list && this.list.length > 0) {
        var page = this.list[0].totalrows / 10;
        if (page % 1 != 0) {
          page = page + 1;
        }
        return Math.floor(page);
      } else {
        return 0;
      }
    }
  },
  methods: {
    changePage(e) {
      this.currentPage = e;
      this.$emit("refreshPage", {
        providerType: this.providerType,
        pageNumber: e,
      })
    },
    getBetDetails(item) {
      let providerCode = item.provider_code
      let resultID = item.result_id
      let gameID = item.game_id
      let remark = item.remark
      let path = ""

      switch(providerCode) {
        case "PPC":
          path = "provider/getPPCResult"
          break;
        default:
          path = ""
      }

      if (["YB"].includes(providerCode)) {
        var result = config.lcResultURL + "player_id=" + this.accountID + "&auth_token=" + this.sessionToken + "&result_id=" + resultID
        setTimeout(() => {
          window.open(
            result,
            "info",
            "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
          );
        }) 
      } else {
        let player_id = this.accountID
        let ticket_id = resultID
        let lang_code = this.getLanguage
        this.$store
          .dispatch(path, { player_id, ticket_id, lang_code })
          .then(response => {
            if (response.success == true) {
              setTimeout(() => {
                window.open(
                  response.data,
                  "info",
                  "toolbar=no,scrollbars=no,resizable=no,top=0,left=0,width=480,height=640"
                );
              }) 
            } else {             
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
            }
          })
          .catch(response => {
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
          });
      }
    },
    getBetTypeName(e) {
      return this.$t("m.BT_" + e);
    },
    formatOddsDisplay(odds, bet_type) {
      if (bet_type == "cs") return calc.fmcs(odds);
      else return this.$helpers.fmt(odds);
    },
    getBetDisplay(bet) {
      return this.$helpers.betDisplay(bet, this);
    },
  }
}
</script>